<template>
  <div class="heads" v-if="imgInfo && imgInfo.length > 0">
    <swiper class="gallery-thumbs swiper2" :options="swiperOptionTop" ref="swiperTop"
      v-if="imgInfo && imgInfo.length > 0">
      <swiper-slide v-for="(item, index) in imgInfo" :key="index" class="w-100">
        <img :src="item" style="height: auto;" />
        <p class="item-title">{{ item.title }}</p>
      </swiper-slide>
    </swiper>
    <div :class="[swidth > 768 ? 'mt-60p' : 'mt-12p', 'm-auto mt-10 relative']"
      :style="{ width: swidth > 768 ? '80%' : '100%' }">
      <div style="color: orangered" class="swiper-button-prev swp1" slot="button-prev">
        <i class="el-icon-arrow-left"></i>
      </div>
      <div style="color: orangered" class="swiper-button-next swp1" slot="button-next">
        <i class="el-icon-arrow-right"></i>
      </div>
      <swiper class=" " :style="{ width: swidth > 768 ? '86%' : '80%' }" :options="swiperOptionMini" ref="swiperMini"
        v-if="imgInfo && imgInfo.length > 0">
        <swiper-slide v-for="(item, index) in imgInfo" :key="index" class="w-25">
          <img :src="item" style="height: auto;" />
          <p class="item-title">{{ item.title }}</p>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  name: "swiper-example-thumbs-gallery",
  title: "Thumbs gallery with Two-way control",
  components: {
    swiper,
    swiperSlide,
  },
  props: {
    imgInfo: [],
    swidth: {
      type: Number
    }
  },
  data() {
    return {
      swiperOptionTop: {
        loop: true,
        loopedSlides: 5,
        centeredSlides: true,
        slidesPerView: "auto",
        touchRatio: 0.2,
        slideToClickedSlide: true,
        navigation: {
          nextEl: ".swiper-button-next.swp1",
          prevEl: ".swiper-button-prev.swp1",
        },
      },
      swiperOptionMini: {
        loop: true,
        loopedSlides: 5,
        spaceBetween: 5,
        slidesPerView: "auto",
        touchRatio: 0.2,
        slideToClickedSlide: true,
        watchSlidesProgress: true
      },
    };
  },
  mounted() {
    this.initSwiper()
  },
  methods: {
    initSwiper() {
      let that = this
      this.$nextTick(() => {
        if (that.$refs.swiperTop && that.$refs.swiperMini) {

          const swiperTop = that.$refs.swiperTop.swiper;
          const swiperMini = that.$refs.swiperMini.swiper;
          swiperTop.controller.control = swiperMini;
          swiperMini.controller.control = swiperTop;
        } else {
          setTimeout(() => {
            that.initSwiper()
          }, 500);
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.swiper-slide img {
  width: 100%;
  object-fit: cover;

}

.swiper-slide {
  // opacity: .3;
}

.swiper-slide-active {
  // opacity: 1;
}

.swiper-button-next,
.swiper-button-prev {
  background-image: none;
  font-size: 40px;
  display: flex;
  align-items: center;
}

.swiper-button-prev,
.swiper-container-rtl .swiper-button-next {
  background-image: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/caseDetails/components/Sapar.vue